export default __webpack_public_path__ + "static/headshot1-9ae5b207908cf3d1ebc32913ab5690a8.png";